import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './NewsDetailPage.css';

const NewsDetailPage = () => {
  const { newsId } = useParams();
  const navigate = useNavigate();

  // News data - you can expand this with more news articles
  const newsData = {
    'new-training-program-launched': {
      title: 'NEW TRAINING PROGRAM LAUNCHED',
      date: '15 Feb 2024',
      image: 'https://images.unsplash.com/photo-1626224583764-f87db24ac4ea?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8YmFkbWludG9ufGVufDB8fDB8fHww&fm=jpg&q=60&w=3000',
      excerpt: 'Advanced coaching techniques and personalized training programs for professional athletes',
      fullContent: `We are excited to announce the launch of our revolutionary new training program designed specifically for professional athletes. This comprehensive program combines cutting-edge coaching techniques with personalized training methodologies to help athletes reach their peak performance.

Our new program features state-of-the-art facilities, advanced sports science integration, and personalized coaching from our team of certified professionals. The program is designed to address the unique needs of each athlete, focusing on both physical and mental development.

Key highlights of the new program include:
- Advanced biomechanical analysis
- Personalized nutrition planning
- Mental conditioning and focus training
- Injury prevention protocols
- Performance tracking and analytics

The program has already shown remarkable results with our initial participants, with significant improvements in performance metrics and overall athlete satisfaction. We believe this program will set a new standard in professional sports training.

Registration is now open for the next intake, with limited spots available. Interested athletes are encouraged to contact our team for more information and to schedule a consultation.`,
      author: 'Sports Alliance Team',
      category: 'Training & Development',
      readTime: '5 min read'
    },
    'nullam-placerat-massa-et': {
      title: 'Vollyball Tranning Athletes',
      date: '04 Jan 2024',
      image: 'https://cdn.prod.website-files.com/632871e15b53a0140af28aeb/671bdf96ac5193b527bd64d8_671aa7d78bbb9fa0e17ae5f1_657387caaba1ba22b89eacf7_Javelin%20Blog%20Images%20(3).jpg',
      excerpt: 'Professional athletes share their training secrets and success strategies',
      fullContent: `In this exclusive interview, we sit down with some of our most successful athletes to discuss their training secrets and the strategies that have led to their remarkable achievements.

Our featured athletes include Olympic medalists, world champions, and rising stars who have all benefited from our comprehensive training programs. They share insights into their daily routines, mental preparation techniques, and the mindset required to excel at the highest levels of competition.

Key topics covered in this comprehensive article include:
- Daily training routines and schedules
- Mental preparation and visualization techniques
- Nutrition and recovery strategies
- Overcoming setbacks and challenges
- Building resilience and mental toughness
- The importance of rest and recovery

The athletes also discuss how our coaching staff has helped them refine their techniques and develop the mental fortitude necessary for elite competition. Their stories serve as inspiration for aspiring athletes and provide valuable insights for anyone looking to improve their performance.

This article is a must-read for anyone serious about athletic development and understanding what it takes to compete at the highest levels.`,
      author: 'Sports Alliance Editorial Team',
      category: 'Athlete Stories',
      readTime: '7 min read'
    },
    'phasellus-nec-metus-scelerisque': {
      title: 'PHASELLUS NEC METUS SCELERISQUE',
      date: '11 Dec 2023',
      image: 'https://thesportsschool.com/wp-content/uploads/2021/12/BB-Top-image-866x487-1.jpg',
      excerpt: 'Professional athletes share their training secrets and success strategies',
      fullContent: `This in-depth analysis explores the latest developments in sports science and how they're being applied to enhance athletic performance. Our research team has been working closely with leading sports scientists to implement cutting-edge techniques in our training programs.

The article covers several groundbreaking areas of research including:
- Advanced biomechanical analysis techniques
- Neuromuscular training protocols
- Recovery and regeneration science
- Performance analytics and data interpretation
- Injury prevention and rehabilitation methods

Our facility has recently invested in state-of-the-art equipment that allows us to provide athletes with detailed insights into their performance. This technology enables our coaches to make data-driven decisions about training modifications and technique improvements.

The results have been impressive, with athletes showing significant improvements in performance metrics, reduced injury rates, and faster recovery times. This research represents a significant step forward in sports training methodology.

We're committed to staying at the forefront of sports science and continuing to provide our athletes with the most advanced training methods available.`,
      author: 'Dr. Sports Science Team',
      category: 'Sports Science',
      readTime: '8 min read'
    },
    'championship-results-announced': {
      title: 'CHAMPIONSHIP RESULTS ANNOUNCED',
      date: '11 Dec 2023',
      image: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&h=500&fit=crop&crop=center',
      excerpt: 'Outstanding performances and record-breaking achievements in the latest tournament',
      fullContent: `The latest championship tournament has concluded with outstanding performances and several record-breaking achievements by our athletes. The competition featured athletes from across multiple disciplines, showcasing the depth and quality of our training programs.

Championship Highlights:
- 15 gold medals across various events
- 3 new national records set
- 8 personal best performances
- Outstanding team spirit and sportsmanship
- Record attendance and community support

Our athletes demonstrated exceptional skill, determination, and sportsmanship throughout the competition. The results reflect the effectiveness of our comprehensive training programs and the dedication of both our athletes and coaching staff.

Special recognition goes to our standout performers who achieved personal bests and set new records. Their success is a testament to the quality of our training programs and the commitment of our coaching team.

The championship also highlighted the strong community support for our athletes, with record attendance and enthusiastic cheering throughout the events. This support plays a crucial role in motivating our athletes to achieve their best performances.

We're proud of all our athletes and look forward to continued success in future competitions. The results from this championship provide strong motivation for continued improvement and excellence.`,
      author: 'Championship Committee',
      category: 'Competition Results',
      readTime: '6 min read'
    }
  };

  const news = newsData[newsId];

  if (!news) {
    return (
      <div className="news-detail-page">
        <div className="container">
          <div className="error-message">
            <h1>Article Not Found</h1>
            <p>The requested article could not be found.</p>
            <button onClick={() => navigate('/')} className="back-btn">
              Back to Home
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="news-detail-page">
      <div className="container">
        <button onClick={() => navigate('/')} className="back-btn">
          ← Back to Home
        </button>
        
        <article className="news-article">
          <header className="article-header">
            <div className="article-meta">
              <span className="article-category">{news.category}</span>
              <span className="article-date">{news.date}</span>
              <span className="article-read-time">{news.readTime}</span>
            </div>
            <h1 className="article-title">{news.title}</h1>
            <p className="article-excerpt">{news.excerpt}</p>
            <div className="article-author">
              <span>By {news.author}</span>
            </div>
          </header>
          
          <div className="article-image">
            <img src={news.image} alt={news.title} />
          </div>
          
          <div className="article-content">
            {news.fullContent.split('\n\n').map((paragraph, index) => (
              <p key={index} className="article-paragraph">
                {paragraph}
              </p>
            ))}
          </div>
          
          <div className="article-tags">
            <span className="tag">Sports Training</span>
            <span className="tag">Athlete Development</span>
            <span className="tag">Performance</span>
          </div>
          
          <div className="article-actions">
            <button className="share-btn">Share Article</button>
            <button className="print-btn">Print Article</button>
          </div>
        </article>
      </div>
    </div>
  );
};

export default NewsDetailPage;
